
export default function Genero({ genero }) {
    return (
        <>
            {genero === 'M' && 'Masculino'}
            {genero === 'F' && 'Feminino'}
        </>
    )
}